import { blobToBase64 } from './contractOrderPaymentApi';
function parseFilename(disposition) {
    const encodedName = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
    const name = /filename="([^"]+)"/i.exec(disposition)?.[1] ?? /filename=([^;]+)/i.exec(disposition)?.[1]?.trim();
    if (!encodedName) {
        return name ?? null;
    }
    try {
        return decodeURIComponent(encodedName);
    }
    catch {
        return name ?? null;
    }
}
export async function parsePdfResponse(response) {
    if (!response.ok) {
        return response.json();
    }
    if (!response.headers.get('content-type')?.toLowerCase().startsWith('application/pdf')) {
        throw new Error('Invalid PDF content type');
    }
    const blob = await response.blob();
    const bytes = new Uint8Array(await blob.arrayBuffer());
    const tail = String.fromCodePoint(...bytes.subarray(Math.max(0, bytes.length - 1024)));
    if (String.fromCodePoint(...bytes.subarray(0, 5)) !== '%PDF-' || !tail.includes('%%EOF')) {
        throw new Error('Invalid PDF content');
    }
    const filename = parseFilename(response.headers.get('content-disposition') ?? '');
    return { base64: await blobToBase64(blob), filename };
}
